<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_160.png" alt="logo图">
    </div>
    <p class="title">杭州腾仑科技有限公司</p>
    <p class="address_tel_fax">
      <div>地址：浙江省杭州市拱墅区华滋科欣设计创意园2号楼606室</div>
      <div>Tel：15867175330</div>
      <div>微信号：luoyi_3944513</div>
<!--      <span>Fax：8888-88888888</span>-->
    </p>
    <p class="email_wx">
<!--      <span>邮箱：liyunkun_11@163.com</span>-->
<!--      <span>公司微信号：ilyk_gg</span>-->
    </p>
    <p class="copy">Copyright &copy; 2020 - 2021 杭州腾仑科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.logo img{
  width:60px;
  height:60px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue